import type { UserReturnDto } from '@skillarea/lib-shared';

import { useBalance } from '~/stores/accountStore';
import { useUserAvatar, useUserName } from '~/stores/userStore';

export function useHeaderUser(
  contextUser: UserReturnDto | null | undefined,
  isLoggedIn: boolean,
): { name: string; avatar?: string; balance: number } | undefined {
  const name = useUserName();
  const avatar = useUserAvatar();
  const balance = useBalance();

  if (!isLoggedIn) return undefined;

  return {
    name: contextUser?.name ?? name,
    avatar: contextUser?.avatar ?? avatar,
    balance,
  };
}
